/* eslint-disable no-console */
function _hj(method: string, ...args: any[]) {
  if (window.hj) {
    window.hj('consent', true)
    window.hj(method, ...args)
  }
  else {
    console.warn('[hotjar] is not available')
  }
}

export default {
  identify: (id: string | number, properties: Record<string, any>) => {
    // request use cookie consent before identifying the user
    _hj('identify', id, properties)
  },
  track: (event: string, properties: Record<string, any> | string) => {
    if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'staging') {
      console.info('[hotjar] track', event, properties, '🔥')
    }
    _hj('event', event, properties)
  },
  pageView: (url: string) => {
    if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'staging') {
      console.info('[hotjar] pageView', url, '🔥')
    }
    _hj('vpv', url)
  },
  setUserProperties: (properties: Record<string, any>) => {
    if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'staging') {
      console.info('[hotjar] setUserProperties', properties, '🔥')
    }
    _hj('setUserProperties', properties)
  },
}
